import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "pinHidden", "submit", "loading"]

  connect() {
    this.#setupDigitInputs()
  }

  handleSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.style.display = "none"
    }
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = "flex"
    }
  }

  #setupDigitInputs() {
    this.digitTargets.forEach((digit, idx) => {
      digit.addEventListener("input", (e) => {
        const val = e.target.value.replace(/\D/g, "")
        e.target.value = val.slice(0, 1)
        if (val && idx < 5) this.digitTargets[idx + 1]?.focus()
        this.#syncPin()
      })

      digit.addEventListener("keydown", (e) => {
        if (e.key === "Backspace" && !e.target.value && idx > 0) {
          this.digitTargets[idx - 1].focus()
          this.digitTargets[idx - 1].value = ""
          this.#syncPin()
        }
        if (!/^\d$/.test(e.key) && !["Backspace", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)) {
          e.preventDefault()
        }
      })

      digit.addEventListener("paste", (e) => {
        e.preventDefault()
        const pasted = (e.clipboardData || window.clipboardData)
          .getData("text").replace(/\D/g, "").slice(0, 6)
        pasted.split("").forEach((ch, i) => {
          if (this.digitTargets[i]) this.digitTargets[i].value = ch
        })
        this.digitTargets[Math.min(pasted.length, 5)]?.focus()
        this.#syncPin()
      })
    })
  }

  #syncPin() {
    const pin = this.digitTargets.map(d => d.value).join("")
    if (this.hasPinHiddenTarget) this.pinHiddenTarget.value = pin
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = pin.length !== 6
      this.submitTarget.style.opacity = pin.length === 6 ? "1" : "0.4"
    }
  }
}
